<template>
    <b-card
     bg-variant="light"
     id="selected-box"
    >
      <ul class="list-inline mb-0">
        <li class="list-inline-item">
          <p class="mb-0"><b-badge variant="primary">{{ results.length }}</b-badge> - <b> <translate>Selected tours</translate></b></p>
        </li>
        <li class="list-inline-item">
          <b-btn variant="warning" size="sm" @click="$emit('info')" v-translate>Generate PDF</b-btn>
        </li>
        <li class="list-inline-item">
          <b-btn variant="outline-secondary" class="btn-sm close" @click="$emit('hide')">
            <b-icon icon="x"/>
          </b-btn>
        </li>
      </ul>
    </b-card>
</template>

<script>
export default {
  name: 'selectedResults',
  props: ['results']
}
</script>
